import { Injectable, NgZone, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, fromEvent, merge, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../../features/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {
  private readonly router = inject(Router);
  private readonly ngZone = inject(NgZone);
  private readonly authService = inject(AuthService);

  private readonly userActivityEvents$ = merge(
    fromEvent(window, 'mousemove'),
    fromEvent(window, 'mousedown'),
    fromEvent(window, 'keyup'),
    fromEvent(window, 'touchstart'),
    fromEvent(window, 'scroll')
  );

  private readonly idleTimer$ = new Subject<void>();
  private readonly IDLE_TIME = 30 * 60 * 1000; // 30 minutes

  startWatching(): void {
    this.ngZone.runOutsideAngular(() => {
      this.userActivityEvents$
        .subscribe(() => this.resetTimer());

      this.idleTimer$
        .pipe(
          switchMap(() => timer(this.IDLE_TIME))
        )
        .subscribe(() => {
          this.ngZone.run(() => this.logout());
        });
    });

    this.resetTimer();
  }

  resetTimer(): void {
    this.idleTimer$.next();
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/auth']);
  }
}